/*******
** Loader
** ------------
** Managing all DOM loading manipulations
*******/
App.Loader = (function() {

	// Constants
	var selectors = {
		team: {
			block: ".block-team-grid",
			container: ".content",
			thumb: ".person-thumb",
			button: ".load-more",
			diff: ".name"
		},
		investment: {
			block: ".block-investment-grid",
			container: ".content",
			thumb: ".investment-thumb",
			counter: ".results-showing",
			button: ".load-more",
			diff: ".title"
		},
		news: {
			block: ".block-news-grid",
			container: ".content",
			thumb: ".news-article-thumb",
			counter: ".results-showing",
			button: ".load-more",
			diff: ".title"
		}
	};

	var flags = {
		LOADING: "loading",
		ADDED: "added"
	};

	function loadMoreGridResults(url, typeSelectors) {
		// Init new loader
		if(!url) {
			url = window.location.pathname;
		}
		var loader = new DOMLoader(url, typeSelectors.block);

		loader.load(
			// On Success
			function(domPartial) {

				var newBlock = $(domPartial);
				var block = $(typeSelectors.block);

				// Remove loading class
				$(typeSelectors.button).removeClass(flags.LOADING);

				// Get the children in the grid
				var newChildren = newBlock.find(typeSelectors.thumb);

				if(newChildren.length) {

					// Get grid
					var container = block.find(typeSelectors.container);
					var children = container.children(typeSelectors.thumb);

					// Remove duplicates from results
					var uniqueNewChildren = newChildren.filter(function(i, newChild) {

						var inArray = true;
						var diff = $(newChild).data('entry-id');

						// Check if this item exists in the DOM already
						children.each(function(i, child) {

							// GO by name as the DOM elements vary
							if(diff == $(child).data('entry-id')) {
								inArray = false;
							}
						});
						return(inArray);
					});

					App.log("Loader: [Rendering]", uniqueNewChildren);

					// Update any overlay hooks
					// Add them to the grid
					if(uniqueNewChildren.length) {

						// Y postition
						var oldScrollY = window.scrollY;

						// Append DOM items
						container.append(uniqueNewChildren);

						// Add overlay handlers
						App.Overlay.addPersonOverlayLinks();

						// Animate
						gsap.fromTo(uniqueNewChildren, { opacity:0 }, {
							opacity:1,
							duration:2,
							ease: App.Animations.GSAP.EASE
						});

						// Reset overlay openers
						// window.App.Overlays.resetOverlayOpeners();

						// Animate to new position
						// gsap.to(window, { duration: 1, scrollTo: { y: uniqueNewChildren.eq(0)[0], offsetY: 200 }, ease: App.Animations.GSAP.EASE });
						window.scrollTo(0, oldScrollY);

						// Update any counters
						if(typeSelectors.counter) {
							var counter = $(typeSelectors.counter);
							if(counter.length) {
								var current = Number(counter.text());
								counter.text(current + uniqueNewChildren.length);
							}
						}
					}
				}

				// Check the more button, does it exist?
				var newBtn = newBlock.find(selectors.team.button);
				var btn = $(typeSelectors.block + " " + typeSelectors.button);
				if(newBtn.length) {

					// Find existing button in real DOM and replace HREF
					btn.attr("href", newBtn.attr("href"));
				} else {

					// There is no button in the results, so remove it locally
					btn.remove();
				}
			},

			// On Error
			function(data) {
				console.log(data); // NOTE: Regular 200 messages!
			}
		);
	}


	function attachLoadMoreHandler(type) {
		try {

			// Get the selectors from the handle set
			var typeSelectors = selectors[type];

			// Get the button
			var btn = $(typeSelectors.block + " " + typeSelectors.button);

			// Add click handlers
			btn.on("click", this, function() {

				// Only operate if not loading
				if(!btn.hasClass(flags.LOADING)) {

					// Attach LOADING class
					btn.addClass(flags.LOADING);

					// Get results
					loadMoreGridResults(
						btn.attr("href"),
						typeSelectors
					);
				}

				// Stop bubble
				return(false);
			});

		} catch(e) {
			App.log("Issue attaching load more handler", e);
		}
	}

	App.register(function() {
		App.log("Registered: App.Loader");
	});

	return {
		addTeamLoader: function() {
			attachLoadMoreHandler("team");
		},
		addInvestmentLoader: function() {
			attachLoadMoreHandler("investment");
		},
		addNewsLoader: function() {
			attachLoadMoreHandler("news");
		}
	}

})();
